import React from 'react'
import './styles.scss'

import content from './footer.json'

export default function Footer() {
  return (
    <footer className="ft-wrapper">
      <div className="container footer">
      <div className="grid row">
			<div className="grid__item col-4--small col-sm-4">
      <img src="https://studiogritt.files.wordpress.com/2018/04/logod12x-e1524694319660.png" style={{ width:'50px', paddingBottom:'20px'}} />
				<p className="meta">#TheAnswerIsDesign</p>
			</div>
			<div className="grid__item col-8--small col-sm-8">
				<div className="footer__copy">
					<p className="lead mb0">We collaborate with ambitious brands and people; we’d love to build something great together.</p>
					<p className="lead fw-bold"><a href="mailto:hello@studiogritt.com" className="link-hover">hello@studiogritt.com</a></p>
				</div>
				<div className="footer__contact-info grid row grid--mobile">
					<div className="grid__item col-lg-4 col-md-6 col-sm-12  col-6 col-3--large mb3 mb0--large">
						<p className="fw-bold">Office</p>
						<p>
							<a href="https://www.google.co.in/maps/place/Studio+Gritt/@12.9405085,77.6233863,15z/data=!4m5!3m4!1s0x0:0x2bcdf90c0082a20d!8m2!3d12.9405085!4d77.6233863" target="_blank" className="address link-hover no-underline" >
								Bangalore 	</a>
                <span style={{ display:'block', fontSize:'1.4rem' }}> 5th Floor, 439, 18th Main, Koramangala 6th Block</span>
						
						</p>
					
					</div>
					<div className="grid__item col-md-6 col-lg-4 col-sm-12 col-6 col-3--large mb3 mb0--large">
						<p className="fw-bold">Start a conversation</p>
						<p>
							<a href="mailto:hello@studiogritt.com" className="link-hover">hello@studiogritt.com</a>
						</p><p>
							<a href="tel:+91 78297 60981" className="link-hover no-underline" >+91 9480848582</a>
						</p>
					</div>
				
					<div className="grid__item col-md-6 col-lg-4 col-sm-12  col-6 col-3--large mb5 mb0--large">
						<p className="fw-bold">Social</p>
						<p>
							<a href="https://www.facebook.com/studiogrittindia/" className="link-hover" target="_blank" onclick="ga('send', 'event', 'exit-facebook', 'click', 'BASIC Facebook', {'NonInteraction': 1});">Facebook</a>
            </p>
            {/* <p>
              <a href="https://twitter.com/studiogritt" className="link-hover" target="_blank" onclick="ga('send', 'event', 'exit-facebook', 'click', 'BASIC Twitter', {'NonInteraction': 1});">Twitter</a>
              </p> */}
              
              <p>
            	<a href="https://www.instagram.com/studiogritt/" className="link-hover" target="_blank" onclick="ga('send', 'event', 'exit-facebook', 'click', 'BASIC Instagram', {'NonInteraction': 1});">Instagram</a>
						</p>
					</div>
				</div>
			</div>
		</div>
      </div>
    </footer>
  )
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js